import type { ColumnField } from '../server/types'

function DefaultCellRenderer<T extends Record<string, unknown>, K extends ColumnField<T>>({
  value,
}: {
  value: T[K]
}): React.ReactNode {
  return <span>{String(value)}</span>
}

export default DefaultCellRenderer
